import { GetCompanyResponse } from '@Common/types/bo_external/companies';

export const companiesTranslations = {
  fields: {
    id: 'Company ID',
    street: 'Street',
    postalcode: 'Postal code',
    city: 'City',
    country: 'Country',
    name: 'Name',
    siret: 'Siret',
    legal_form: 'Legal form',
    registration_date: 'Registration date',
    headcount: 'Headcount',
    created_at: 'Created at',
    updated_at: 'Updated at',
    logo_url: 'Company logo',
    start_fiscal_year: 'End of Fiscal Year (DD/MM)',
    naf_code: 'NAF/APE code',
    previous_naf_code: 'Previous NAF/APE code',
    rcs_location: 'RCS location',
    collective_agreement_code: 'Collective Agreement Code (IDCC)',
    collective_agreement_name: 'Collective Agreement Name',
    has_documents: 'Has documents',
    contacts: 'Contacts',
    domains: 'Email domains',
    mailing_street: 'Street',
    mailing_postalcode: 'Postal code',
    mailing_city: 'City',
    mailing_country: 'Country',
    billing_street: 'Street',
    billing_postalcode: 'Postal code',
    billing_city: 'City',
    billing_country: 'Country',
    retirement_age: 'Retirement age',
    international_identifier: 'International Identifier',
    is_international: 'Is international',
    has_indirect_management_contract: 'Has indirect management contract',
    has_payment_methods: 'Has payment methods',
    has_ccb: 'Has CCB',
  } satisfies Record<keyof GetCompanyResponse, string>,
  tabs: {
    details: {
      label: 'Details',
      headers: {
        financial_information: 'Financial Information',
        address: 'Address',
        mailing_address: 'Mailing Address',
        billing_address: 'Billing Address',
      },
    },
    fees: {
      label: 'Fees',
    },
    representative: {
      label: 'Representative',
      headers: {
        legal_representative: 'Legal Representatives',
        business_correspondent: 'Business Correspondents',
      },
      fields: {
        id: 'ID',
        role: 'Role in company',
        firstname: 'First Name',
        lastname: 'Last Name',
        email: 'Email',
        landline: 'Landline phone number',
        phone_number: 'Mobile phone number',
        is_business_correspondent: 'Is business correspondent',
      },
    },
    admins: {
      label: 'Correspondents',
    },
    plans: {
      label: 'Plans',
    },
    documents: {
      label: 'Documents',
    },
    dashboard: {
      label: 'Dashboard',
    },
    payment_methods: {
      label: 'Payment methods',
    },
  },
  choices: {
    created: 'Created',
    in_review: 'Under review',
    verified: 'KYB Completed',
    denied: 'Denied',
    resigned: 'Resigned',
  },
  dashboard: {
    active_campaigns: {
      title: {
        singular: 'Active operation',
        plural: 'Active operations',
      },
      participation: 'Participation',
      operation_id: 'Operation ID',
      status: 'Status',
      amount: 'Amount',
      in_progress: 'In progress',
      answer_rate: 'Answer rate',
      of_affiliates_answered: 'of affiliates answered',
      no_active_campaigns: 'No active campaigns',
      create: 'Create',
    },

    titles: {
      matching_contribution: 'Matching contribution',
      matching_contribution_details: 'Matching contribution details',
      savings: 'Savings',
      latest_documents: 'Latest documents',
      affiliates: 'Year to date number of affiliates who',
    },
    see_all: 'See all',
    matching_contribution: {
      data_for_year: 'Matching contribution breakdown for %{year}',
      paid: 'Already paid',
      awaiting_company: 'Awaiting company',
      not_distributed: 'Not distributed',
      potential_payout: 'Total potential payout',
      topped_limit: 'Employee topped out their limit',
      optimised: 'Employee optimised their matching contribution',
      not_used: "Employee haven't used their matching contribution",
    },
    savings: {
      per_product: 'Per product',
      per_fund: 'Per fund',
      total_savings: 'Total Savings',
      other: 'Other',
    },
    affiliates: {
      made_arbitrage: 'Made an arbitrage',
      made_voluntary_deposit: 'Made a voluntary deposit',
    },
  },
};
